export default __webpack_public_path__ + "static/media/honda_ap.990697fa.png";